// Vendors
import { useEffect, useState } from 'react';
// Constants
import { RESIZE_EVENT } from '../constants/cancel-drop-modal.constants';
import { ONBOARDING_GIL_MODAL_SHOW_MODAL } from './constants/cancel-drop-modal.hook.constants';
// Event Handlers
import CancelDropModalHandlers from '../handlers/cancel-drop-modal.handlers';
import { LogHandlers } from 'handlers/log.handlers';
// Types
import {
  CancelDropModalBuilderHookReturnType,
  CancelDropModalHookReturnType,
} from './types/cancel-drop-modal.hook.type';
// Utilities
import { getModalMaxWidth } from '../utils/cancel-drop-modal.component.utils';

const CancelDropModalHook = ({
  id,
  showModal,
  onOpenModal,
}: CancelDropModalBuilderHookReturnType): CancelDropModalHookReturnType => {
  const [maxWidth, setMaxWidth] = useState(getModalMaxWidth());

  const { handleRecalculateWidth } = CancelDropModalHandlers({ setMaxWidth }),
    { handleSendCustomActionEvent } = LogHandlers();

  useEffect(() => {
    window.addEventListener(RESIZE_EVENT, handleRecalculateWidth);
    return () => {
      window.removeEventListener(RESIZE_EVENT, handleRecalculateWidth);
    };
  }, []);

  useEffect(() => {
    if (showModal) {
      // eslint-disable-next-line security/detect-object-injection -- id is a controlled enum value
      handleSendCustomActionEvent(ONBOARDING_GIL_MODAL_SHOW_MODAL[id]);
      onOpenModal?.();
    }
  }, [showModal]);

  return { maxWidth };
};

export default CancelDropModalHook;
